import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/blog-detail-page.tsx");
